/**
 * Petit stockage clé → valeur sur l'appareil (IndexedDB), pour la caisse hors ligne :
 * catalogue, moyens de paiement, ventes en attente d'envoi.
 * Si IndexedDB est indisponible (navigation privée…), on se rabat sur localStorage.
 */
const BASE = "boutique-pro";
const TABLE = "donnees";
let ouverture = null;

function ouvrir() {
  if (ouverture) return ouverture;
  ouverture = new Promise((resolve) => {
    try {
      if (!window.indexedDB) return resolve(null);
      const req = indexedDB.open(BASE, 1);
      req.onupgradeneeded = () => req.result.createObjectStore(TABLE);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => resolve(null);
      req.onblocked = () => resolve(null);
    } catch (e) {
      resolve(null);
    }
  });
  return ouverture;
}

async function operation(mode, fn) {
  const db = await ouvrir();
  if (!db) return undefined;
  return new Promise((resolve) => {
    try {
      const tx = db.transaction(TABLE, mode);
      const req = fn(tx.objectStore(TABLE));
      tx.oncomplete = () => resolve(req?.result);
      tx.onerror = () => resolve(undefined);
      tx.onabort = () => resolve(undefined);
    } catch (e) {
      resolve(undefined);
    }
  });
}

export async function lire(cle, defaut = null) {
  const db = await ouvrir();
  if (!db) {
    try { const v = localStorage.getItem("bp:" + cle); return v === null ? defaut : JSON.parse(v); } catch (e) { return defaut; }
  }
  const v = await operation("readonly", s => s.get(cle));
  return v === undefined ? defaut : v;
}

export async function ecrire(cle, valeur) {
  const db = await ouvrir();
  // Copie simple (objets réactifs Vue non clonables par IndexedDB)
  const brut = valeur === undefined ? null : JSON.parse(JSON.stringify(valeur));
  if (!db) {
    try { localStorage.setItem("bp:" + cle, JSON.stringify(brut)); } catch (e) { /* plein */ }
    return;
  }
  await operation("readwrite", s => s.put(brut, cle));
}

export async function supprimer(cle) {
  const db = await ouvrir();
  if (!db) { try { localStorage.removeItem("bp:" + cle); } catch (e) { /* rien */ } return; }
  await operation("readwrite", s => s.delete(cle));
}
